// @ai-generated 2026-09-07T00:00:00+00:00 by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
import { AGENTIC_ORCHESTRATOR_API } from '@Constants/backendConstants';
import { type Result, useLogger, useSynqoHttp } from '@synqo/frontend-component-library';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

// Declared here rather than imported from @Model: TypeGen's library list does not cover
// Model.Api.Commands, so no command has a generated model.

/** The `workflows:run.v1` command payload. */
interface RunWorkflowCommand {
    workflow_definition_id: string;
}

/** What an asynchronous command answers with. */
interface CommandExecutionHandle {
    /** The command execution's id, not the workflow run's, despite the name the framework gives it. */
    run_id: string;
    status: number;
}

/**
 * Starts a workflow run outside the chat. The run outlives the request, so this resolves once it has
 * been accepted — what comes back names the command execution that will carry it out.
 */
export function useStartWorkflowRun() {
    const { info } = useLogger();
    const { post } = useSynqoHttp(`${AGENTIC_ORCHESTRATOR_API}/workflows:run.v1`);

    const { mutateAsync: startRun, isPending: isStartPending } = useMutation({
        mutationFn: (command: RunWorkflowCommand) =>
            post<Result<CommandExecutionHandle>, RunWorkflowCommand>('', command),
    });

    const startWorkflow = useCallback(
        (workflowDefinitionId: string) => {
            info(`Starting workflow ${workflowDefinitionId}`);
            return startRun({ workflow_definition_id: workflowDefinitionId });
        },
        [info, startRun],
    );

    return { startWorkflow, isStartPending };
}
